import { Link } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

type NavKey = 'platform' | 'features' | 'pricing';

interface MarketingNavProps {
  /** Highlights the matching center link. */
  active?: NavKey;
}

/**
 * Marketing nav — "banker-paper" sticky cream bar.
 * Center links: Platform · Features · Pricing (per product decision).
 * Right: Sign in / Dashboard + "Request a demo".
 * Scoped under `.clarid-marketing` so it never touches the authed app.
 */
export default function MarketingNav({ active }: MarketingNavProps) {
  const { user } = useAuthStore();

  return (
    <header className="nav">
      <div className="container nav-inner">
        <Link to="/" aria-label="Clarid home">
          <img src="/clarid-logo-marketing.png" alt="clarid.ai" className="nav-logo" />
        </Link>
        <nav className="nav-links">
          <Link to="/#platform" className={`nav-link${active === 'platform' ? ' active' : ''}`}>
            Platform
          </Link>
          <Link to="/features" className={`nav-link${active === 'features' ? ' active' : ''}`}>
            Features
          </Link>
          <Link to="/pricing" className={`nav-link${active === 'pricing' ? ' active' : ''}`}>
            Pricing
          </Link>
        </nav>
        <div className="nav-cta">
          {user ? (
            <Link to="/dashboard" className="btn btn-primary">
              Dashboard
            </Link>
          ) : (
            <>
              <Link to="/login" className="nav-link">
                Sign in
              </Link>
              <Link to="/request-demo" className="btn btn-primary">
                Request a demo
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
